import * as Sentry from '@sentry/react'
import {BrowserTracing} from '@sentry/tracing'

import {sanitizeSentryPayload} from './sentrySanitize'

export default function sentry() {
  if (ENV !== 'development') {
    try {
      Sentry.init({
        dsn: XC_SENTRY_CLIENT,
        tracesSampleRate: 1, // 用户少，先用1
        integrations: [new BrowserTracing()],
        beforeSend(event) {
          return sanitizeSentryPayload(event)
        },
        beforeSendTransaction(event) {
          return sanitizeSentryPayload(event)
        },
      })
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error)
    }
  }
}
